import React from 'react';

const WorkflowApprovalForm = () => {
  return (
    <div className="w-full bg-white border border-gray-200 shadow-md rounded-xl p-6 text-gray-800 space-y-5 text-[13px]">
      <h2 className="text-base font-semibold text-gray-800">🧾 Procurement Approval Request</h2>

      {/* Procurement Request Details */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs text-gray-600 mb-1">Request ID</label>
          <input
            type="text"
            disabled
            value="REQ-2025-0231"
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2 text-[13px]"
          />
        </div>

        <div>
          <label className="block text-xs text-gray-600 mb-1">Requested By</label>
          <input
            type="text"
            disabled
            value="Adeel Zafar"
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2 text-[13px]"
          />
        </div>

        <div>
          <label className="block text-xs text-gray-600 mb-1">Department</label>
          <input
            type="text"
            disabled
            value="Procurement"
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2 text-[13px]"
          />
        </div>

        <div>
          <label className="block text-xs text-gray-600 mb-1">Vendor</label>
          <input
            type="text"
            disabled
            value="Tech Supplies Inc."
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2 text-[13px]"
          />
        </div>

        <div>
          <label className="block text-xs text-gray-600 mb-1">Total Amount</label>
          <input
            type="text"
            disabled
            value="$23,780.00"
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2 text-[13px]"
          />
        </div>

        <div>
          <label className="block text-xs text-gray-600 mb-1">Expected Delivery</label>
          <input
            type="text"
            disabled
            value="2025-07-12"
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2 text-[13px]"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-xs text-gray-600 mb-1">Items Summary</label>
          <textarea
            disabled
            rows={3}
            value="• 50 Office Chairs\n• 20 Adjustable Tables\n• 10 LED Screens"
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2 text-[13px] whitespace-pre-line"
          ></textarea>
        </div>
      </div>

      {/* Approver's Comment */}
      <div>
        <label className="block text-xs text-gray-600 mb-1">Comment (required)</label>
        <textarea
          placeholder="Add your remarks or justification..."
          rows={3}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-[13px] focus:outline-indigo-500"
        ></textarea>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end gap-3">
        <button className="bg-red-500 hover:bg-red-600 text-white text-sm font-medium px-4 py-2 rounded-md transition">
          Reject
        </button>
        <button className="bg-green-600 hover:bg-green-700 text-white text-sm font-medium px-4 py-2 rounded-md transition">
          Approve
        </button>
      </div>
    </div>
  );
};

export default WorkflowApprovalForm;
